import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsPeriodAvailable } from '../../../../selectors/publishTerms';
import { PlacingPeriodTitle } from './PlacingPeriodTitle';

export const PlacingPeriodTitleContainer = () => {
  const isPeriodAvailable = useSelector(selectIsPeriodAvailable);

  if (!isPeriodAvailable) {
    return null;
  }

  return <PlacingPeriodTitle />;
};
